import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, Container, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { ComponentRoles } from './ComponentRoles';
import { ComponentUser } from './ComponentUser';
import { TabMenu } from 'primereact/tabmenu';
import { useModal as useMorphingModal } from "react-morphing-modal";
import { useHistory } from 'react-router-dom';
import { Modal } from "react-morphing-modal";

export const IndexUserRole = (props) => {

    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (e) => {
        setActiveTab(e.index);
    }

    // const items = [
    //     { label: 'Usuarios', icon: 'pi pi-users' },
    //     { label: 'Roles', icon: 'pi pi-key' }
    // ];

    // * NEW CONFIGURATION
    const [key, setKey] = useState(0);
    const history = useHistory();
    const modalFullRefs = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);




    const {
        open: openReportModal,
        close: closeReportModal,
        modalProps: reportModalProps,
    } = useMorphingModal({
        onClose: () => {
            setKey((key) => key + 1);
            history.push(`../dashboard/default`);
        },
        background: "#fff",
    });


    const handleReports = (receptor) => {
        openReportModal(modalFullRefs);
    };

    useEffect(() => {
        handleReports();
    }, []);

    // ? MENU
    const items =
        [
            { label: 'Usuarios', icon: 'pi pi pi-users' },
            { label: 'Roles', icon: 'pi pi-id-card' },
        ]


    return (
        <Fragment>

            <Col sm="12" className='container-global-zoom pb-5' >

                <TabMenu
                    model={items}
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                    }}
                    className="custom-tabmenu full-width custom-tabmenu-orange"
                    style={{ marginBottom: "15px" }}
                />
                {
                    activeIndex === 0 && (
                        <Col sm="12">
                            <ComponentUser {...{ ...props, activeTab }} />
                        </Col>
                    )
                }
                {
                    activeIndex === 1 && (
                        <Col sm="12">
                            <ComponentRoles {...{ ...props, activeTab }} />
                        </Col>
                    )
                }
            </Col>

        </Fragment>

    )
}